import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'

const HelpLink = ({ hide = false }) => {

  return <NavLink to={'/help'} className={({ isActive }) => isActive ? 'hidden md:hidden' : ''}>
    <div className={hide ? 'hidden' : 'bg-white rounded-full border border-orange-400 w-9 h-9 p-1 md:hidden'}>
      <img src="/helpIcon.png" alt='Help link' />
    </div>
    <div className={'hidden md:inline-block text-xl font-semibold mx-1 border-l-4 border-t-4 border-current px-1  hover:border-orange-400 cursor-pointer'}>
            Help
    </div>
  </NavLink>
}

HelpLink.propTypes = {
  hide: PropTypes.bool,
}

export default HelpLink
